export default __webpack_public_path__ + "741ad22bbac7489d27c3c7d7b572d63f.png";